export default ({ app, route }, inject) => {
  const extendPath = (currentPath, extendedPath) => {
    return currentPath.replace(/\/+$/, "") + '/' + extendedPath.replace(/^\//, "");
  }
  inject('extendPath', extendPath);
}